import type { AnalysisNiche } from '@/features/analysisPageNiches/types';
import type { GetAnalysisNichesQuery } from '@/shared/hooks/queries/generated';

export const mapAnalysisNiches = (data: GetAnalysisNichesQuery['getAnalysisNiches']): AnalysisNiche[] => {
  if (!data) return [];

  return data.map((item) => ({
    type: item.type as AnalysisNiche['type'],
    niche: item.niche,
    imageUrl: item.imageUrl,
    avgPrice: item.avgPrice,
    productCount: item.productCount,
    soldPct: item.soldPct,
    soldPerDay: item.soldPerDay,
    addedPerDay: item.addedPerDay,
    timeToSellHours: item.timeToSellHours,
  }));
};
